import { BrowserRouter as Router, Routes, Route,Navigate  } from "react-router-dom";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import UserProfile from "./pages/profileview/UserProfile";
import PostDetail from "./pages/homepage/PostDetail.js";
import Publication from "./pages/publications/publication";
import Register from "./pages/register/register";
import LoginPage from "./pages/Login/login";
import EmailVerification from "./pages/Verification/otpVerification";
import ForgotPasswordPage from "./pages/Login/forget_password";
import ChangePasswordPage from "./pages/profileview/Change_Password";
import CreateProfile from "./pages/createProfile/CreateProfile";
import ProfileView from "./pages/profileview/ProfileView";
import HomeTab from "./pages/homepage/home";
import Video from "./pages/video/video";
import Images from "./pages/images/image";
import Code from "./pages/codesnippet/code";
import Portfolio from "./pages/portfolio/portfolio";
import UploadResearch from "./pages/Research/UploadResearch";
import Publish from "./pages/reserchview/reserchInnerPage/Publish";
import PublishSuccess from "./pages/reserchview/reserchInnerPage/PublishSuccess";
import PrivateRoute from "./pages/Verification/PrivateRoute";
import MobileHeader from "./components/MobileHeader.jsx";
import About from "./pages/company/About.jsx";
import Blogs from "./pages/blogs/Blogs.jsx";
import Careers from "./pages/careers/Careers.jsx";
import HelpCenter from "./pages/resources/HelpCenter.jsx";
import ContactUs from "./pages/resources/ContactUs.jsx";
import MarketingSolution from "./pages/business/MarketingSolution.jsx";
import Scientific from "./pages/business/Scientific.jsx";
import PublisherSolution from "./pages/business/PublisherSolution.jsx";
import TermsAndConditions from "./pages/resources/Terms.jsx";
import PrivacyPolicy from "./pages/resources/Privacy.jsx";
import { ProfileProvider } from "./context/ProfileContext.js";
import Copyright from "./pages/resources/Copyright.jsx";
import Imprint from "./pages/resources/Imprint.jsx";
import Consent from "./pages/resources/Consent.jsx";
import ViewerPage from "./components/ViewerPage.jsx";
import Chat from "./components/chat/Chat.jsx";
import "./styles/theme.css";
import Notifications from "./components/notifications/Notifications.jsx";
// Teacher Routes
import useCurrentTeacher from "./hooks/useCurrentTeacher.js";
import TeacherLayout from "./pages/teacherview/TeacherLayout.jsx";
import TeacherDashboard from "./pages/teacherview/dashboard/TeacherDashboard.jsx";
import TeacherCourses from "./pages/teacherview/courses/TeacherCourses.jsx";
import TeacherCourseDetail from "./pages/teacherview/courses/TeacherCourseDetail.jsx";
import TeacherPrfilePage from "./pages/teacherview/profile/TeacherPrfilePage.jsx";
import TeacherProfile from "./pages/teacherview/profile/TeacherProfile.jsx";
import CreateCourse from "./pages/teacherview/courses/CreateCourse.jsx";
import ListCourseContent from "./pages/teacherview/courses/courseContent/ListCourseContent.jsx";
import UploadVideo from "./pages/teacherview/videos/UploadVideo.jsx";
import ListVideos from "./pages/teacherview/videos/ListVideos.jsx";
import ListAudios from "./pages/teacherview/audios/ListAudios.jsx";
import ListPodCasts from "./pages/teacherview/podcasts/ListPodCats.jsx";
import EditCourse from "./pages/teacherview/courses/EditCourse.jsx";
// End of Teacher Rotues
// Courses Routes
import CoursesPage from './pages/coursesview/CoursesPage.jsx'
import CourseDetailsPage from "./pages/coursesview/CourseDetailsPage.jsx";
import TeacherProfilePublicView from './pages/coursesview/TeacherProfilePublicView.jsx'
// End of Courses Routes
// Student Courses
import StudentLayout from "./pages/studentview/StudentLayout.jsx";
import StudentDashboard from "./pages/studentview/StudentDashboard.jsx";
import MyCourses from "./pages/studentview/mycourses/MyCourses.jsx";
import PlayLists from "./pages/studentview/playlists/PlayLists.jsx";
import VideoCourses from "./pages/studentview/video-courses/VideoCourses.jsx";
import AudioCourses from "./pages/studentview/audio-courses/AudioCourses.jsx";
import PodCastCourses from "./pages/studentview/podcast-courses/PodCastCourses.jsx";
import PlayListCourseDetailPage from "./pages/studentview/playlists/PlayListCourseDetailPage.jsx";
import MarketplaceHome from "./pages/marketplace/LandingPage/MarketplaceHome.jsx";
import MarketPlaceLogin from "./components/marketplace/Login.jsx";
import MarketPlaceRegister from './components/marketplace/Signup.jsx'
import OnBoardingHome from "./pages/marketplace/IndependentResearcher/onboarding/OnBoardingHome.jsx";
import IndustryLayout from "./pages/marketplace/Industry/IndustryLayout.jsx";
import UniversityProfile from "./pages/marketplace/Univeristy/UniversityProfile.jsx";
import UniversityApprovedStatus from "./pages/marketplace/Univeristy/StatusMessage.jsx";
import UniversityPayment from "./pages/marketplace/Univeristy/UniversityPayment.jsx";
import IndependentResearcherLayout from "./pages/marketplace/IndependentResearcher/IndependentResearcherLayout.jsx";
import PaymentsPlans from "./pages/marketplace/IndependentResearcher/PaymentsPlans.jsx";
import IndustryProfile from "./pages/marketplace/Industry/IndustryProfile.jsx";
import IndustryStatusMessage from "./pages/marketplace/Industry/IndustryStatusMessage.jsx";
import IndustryPayment from "./pages/marketplace/Industry/IndustryPayment.jsx";
import ResearcherDashboardLayout from "./pages/marketplace/IndependentResearcher/dashboard/ResearcherDashboardLayout.jsx";
import ResearcherDashboard from "./pages/marketplace/IndependentResearcher/dashboard/ResearcherDashboard.jsx";
import UniversityLayout from "./pages/marketplace/Univeristy/UnversityLayout.jsx";
import AddLabExperiment from "./pages/marketplace/IndependentResearcher/dashboard/AddLabExperiment.jsx";
import AddTheoreticalIdea from "./pages/marketplace/IndependentResearcher/dashboard/AddTheoreticalIdea.jsx";
import ResearcherPublications from "./pages/marketplace/IndependentResearcher/dashboard/ResearcherPublications.jsx";
import AddPrototype from "./pages/marketplace/IndependentResearcher/dashboard/AddPrototype.jsx";
import AddIndustrialApplication from "./pages/marketplace/IndependentResearcher/dashboard/AddIndustrialApplication.jsx";
import ResearcherProfile from "./pages/marketplace/IndependentResearcher/dashboard/ResearcherProfile.jsx";
import PublicationDetail from "./pages/marketplace/IndependentResearcher/dashboard/PublicationDetail.jsx";
import UpdatePublication from "./pages/marketplace/IndependentResearcher/dashboard/UpdatePublication.jsx";
import OpportunityHub from "./pages/marketplace/IndependentResearcher/dashboard/OpportunityHub.jsx";
import MyLabSpaces from "./pages/marketplace/IndependentResearcher/dashboard/MyLabSpaces.jsx";
import PublicProfileView from "./pages/marketplace/PublicProfileView.jsx";
import CreateOpportunity from "./pages/marketplace/IndependentResearcher/dashboard/CreateOpportunity.jsx";
import OpportunityDetails from "./pages/marketplace/IndependentResearcher/dashboard/OpportunityDetails.jsx";
import EditOpportunity from "./pages/marketplace/IndependentResearcher/dashboard/EditOpportunity.jsx";
import VideoDetails from "./pages/teacherview/videos/VideoDetails.jsx";
import AudioDetails from "./pages/teacherview/audios/AudioDetails.jsx";
import PodCastDetails from "./pages/teacherview/podcasts/PodCastDetails.jsx";
import EditAudio from "./pages/teacherview/audios/EditAudio.jsx";
import EditPodCast from "./pages/teacherview/podcasts/EditPodCast.jsx";
import EditVideo from "./pages/teacherview/videos/EditVideo.jsx";
import UploadAudio from "./pages/teacherview/audios/UploadAudio.jsx";
import UploadPodCast from "./pages/teacherview/podcasts/UploadPodCast.jsx";
import UniversityDashboard from "./pages/marketplace/Univeristy/dashboard/UniversityDashboard.jsx";
import UniversityUsers from "./pages/marketplace/Univeristy/users/UniversityUsers.jsx";
import AddUniveristyUser from "./pages/marketplace/Univeristy/users/AddUniveristyUser.jsx";
import UniversityDepartments from "./pages/marketplace/Univeristy/departments/UniversityDepartments.jsx";
import AddDepartment from "./pages/marketplace/Univeristy/departments/AddDepartment.jsx";
import DeansList from "./pages/marketplace/Univeristy/departments/HeadofDepartments.jsx";
import AddDean from "./pages/marketplace/Univeristy/departments/AddDean.jsx"
import UpdateDepartments from "./pages/marketplace/Univeristy/departments/UpdateDepartments.jsx";
import UniversityDeanLayout from "./pages/marketplace/universityDeans/UniversityDeanLayout.jsx";
import UniversityDeanDashboard from "./pages/marketplace/universityDeans/UniversityDeanDashboard.jsx";
import DeanUniversityDepartments from "./pages/marketplace/universityDeans/DeanUniversityDepartments.jsx";
import UniversityDeanLabs from "./pages/marketplace/universityDeans/UniversityDeanLabs.jsx";
import UniversityLabHeads from "./pages/marketplace/universityDeans/UniversityLabHeads.jsx";
import AddLabHead from "./pages/marketplace/universityDeans/AddLabHead.jsx";
import LabHeadLayout from "./pages/marketplace/Univeristy/labhead/LabHeadLayout.jsx";
import LabHeadDashboard from "./pages/marketplace/Univeristy/labhead/LabHeadDashboard.jsx";
import LabGroups from "./pages/marketplace/Univeristy/labhead/LabGroups.jsx";
import AddLabGroup from "./pages/marketplace/Univeristy/labhead/AddLabGroup.jsx";
import EditLabGroup from "./pages/marketplace/Univeristy/labhead/EditLabGroup.jsx";
import AddGroupMember from "./pages/marketplace/Univeristy/labhead/AddGroupMember.jsx";
import EditGroupMember from "./pages/marketplace/Univeristy/labhead/EditGroupMember.jsx";
import CreateLabOpportunity from "./pages/marketplace/IndependentResearcher/dashboard/mylabspaces/CreateLabOpportunity.jsx";
import LabOpportunityDetals from "./pages/marketplace/IndependentResearcher/dashboard/mylabspaces/LabOpportunityDetals.jsx";
import EditLabOpportunity from "./pages/marketplace/IndependentResearcher/dashboard/mylabspaces/EditLabOpportunity.jsx";
import AddLabTheoreticalIdea from "./pages/marketplace/IndependentResearcher/dashboard/mylabspaces/AddLabTheoreticalIdea.jsx";
import AddUniLabExperiment from "./pages/marketplace/IndependentResearcher/dashboard/mylabspaces/AddUniLabExperiment.jsx";
import AddLabPrototype from "./pages/marketplace/IndependentResearcher/dashboard/mylabspaces/AddLabPrototype.jsx";
import AddLabIndustrialApplication from "./pages/marketplace/IndependentResearcher/dashboard/mylabspaces/AddLabIndustrialApplication.jsx";
import LabPublicationDetail from "./pages/marketplace/IndependentResearcher/dashboard/mylabspaces/LabPublicationDetail.jsx";
import EditLabPublication from "./pages/marketplace/IndependentResearcher/dashboard/mylabspaces/EditLabPublication.jsx";
import IndustryManagers from "./pages/marketplace/Industry/dashboard/IndustryManagers.jsx";
import AddManager from "./pages/marketplace/Industry/dashboard/AddManager.jsx";
import ManagerLayout from "./pages/marketplace/Industry/manager/ManagerLayout.jsx";
import ManagerDashboard from "./pages/marketplace/Industry/manager/ManagerDashboard.jsx";
import AssistantManager from "./pages/marketplace/Industry/manager/AssistantManager.jsx";
import AddAssistantManager from "./pages/marketplace/Industry/manager/AddAssistantManager.jsx";
import AssistantManagerLayout from "./pages/marketplace/Industry/assistantManager/AssistantManagerLayout.jsx";
import AssistantManagerDashboard from "./pages/marketplace/Industry/assistantManager/AssistantManagerDashboard.jsx";
import Posts from "./pages/marketplace/Industry/assistantManager/Posts.jsx";
import ResearcherPostDetails from "./pages/marketplace/IndependentResearcher/ResearcherPostDetails.jsx";
import UsersInterest from "./pages/marketplace/IndependentResearcher/dashboard/UsersInterest.jsx";
import MarketPlaceFeedLayout from "./pages/marketplace/MarketPlaceFeedLayout.jsx";
import MarketPlaceFeedDetails from "./pages/marketplace/MarketPlaceFeedDetails.jsx";
import UniversityPublicProfile from "./pages/marketplace/UniversityPublicProfile.jsx";
import AddUniversityLab from "./pages/marketplace/universityDeans/AddUniversityLab.jsx";
import Labs from "./pages/marketplace/Univeristy/labhead/Labs.jsx";
import Announcements from "./pages/marketplace/Univeristy/Announcements.jsx";
import CreateAnnouncements from "./pages/marketplace/Univeristy/CreateAnnouncements.jsx";
import AnnouncementDetail from "./pages/marketplace/Univeristy/AnnouncementDetail.jsx";
import DeanAnnouncements from "./pages/marketplace/universityDeans/DeanAnnouncements.jsx";
import CreateDeanAnnouncement from "./pages/marketplace/universityDeans/CreateDeanAnnouncement.jsx";
import DeanAnnouncementDetail from "./pages/marketplace/universityDeans/DeanAnnouncementDetail.jsx";
import LabHeadAnnouncements from "./pages/marketplace/Univeristy/labhead/LabHeadAnnouncements.jsx";
import CreateLabHeadAnnouncements from "./pages/marketplace/Univeristy/labhead/CreateLabHeadAnnouncements.jsx";
import LabHeadAnnouncementDetail from "./pages/marketplace/Univeristy/labhead/LabHeadAnnouncementDetail.jsx";
import MarketPlaceSearchPage from "./pages/marketplace/MarketPlaceSearchPage.jsx";
import UniversityTeachers from "./pages/marketplace/Univeristy/teachers/UniversityTeachers.jsx";
import MarketPlaceChat from "./pages/marketplace/MarketPlaceChat.jsx";
import AddTeacher from "./pages/marketplace/Univeristy/teachers/AddTeacher.jsx";
import Publications from "./pages/marketplace/Univeristy/labhead/Publications.jsx";
import LabHeadOpportunities from "./pages/marketplace/Univeristy/labhead/LabHeadOpportunities.jsx";
import MarketPlaceOpportunityDetails from "./pages/marketplace/MarketPlaceOpportunityDetails.jsx";
const queryClient = new QueryClient();

function App() {
  const {isTeacher}=useCurrentTeacher()

  return (
    <QueryClientProvider client={queryClient}>
      
      <Router>
        <ToastContainer position="top-right" autoClose={1000} />
        <ProfileProvider>
          <Routes>
            <Route path="/" element={<LoginPage />} />
            <Route path="/viewer" element={<ViewerPage />} />
            <Route path="/chat" element={ <PrivateRoute><Chat /></PrivateRoute>}></Route>
            <Route path="/terms" element={<TermsAndConditions />} />
            <Route path="/privacy" element={<PrivacyPolicy />} />
            <Route path="/register" element={<Register />} />
            <Route path="/otp-verification" element={<EmailVerification />} />
            <Route path="/forgot-password" element={<ForgotPasswordPage />} />
            <Route path="/changepassword" element={<ChangePasswordPage />} />
            <Route path="/create-profile" element={<CreateProfile />} />
            <Route path="/mobile-header" element={<MobileHeader />} />
            <Route path="/about" element={<About />} />
            <Route path="/blogs" element={<Blogs />} />
            <Route path="/careers" element={<Careers />} />
            <Route path="/help" element={<HelpCenter />} />
            <Route path="/contact" element={<ContactUs />} />
            <Route path="/marketing" element={<MarketingSolution />} />
            <Route path="/scientific" element={<Scientific />} />
            <Route path="/publisher" element={<PublisherSolution />} />
            <Route path="/copyright" element={<Copyright />} />
            <Route path="/imprint" element={<Imprint />} />
            <Route path="/consent" element={<Consent />} />
            <Route path="/notifications" element={<Notifications />}/>
            {/* Marketplace routes */}
            <Route path="/marketplace" element={<MarketplaceHome/>}/>
            <Route path="/marketplace/search" element={<PrivateRoute><MarketPlaceSearchPage/></PrivateRoute>} />
            <Route path="/marketplace/feed" element={<PrivateRoute><MarketPlaceFeedLayout/></PrivateRoute>} />
            <Route path="/marketplace/chat" element={<PrivateRoute><MarketPlaceChat/></PrivateRoute>} />
            <Route path="/marketplace/university/:id" element={<UniversityPublicProfile/>} />
            <Route path="/marketplace/feed/post/:id" element={<PrivateRoute><MarketPlaceFeedDetails/></PrivateRoute>} />
            <Route path="/marketplace/feed/opportunity/:id" element={<PrivateRoute><MarketPlaceOpportunityDetails/></PrivateRoute>} />
            <Route path="/marketplace/independent_researcher/:id" element={<PublicProfileView/>}/>
            <Route path="/marketplace/independent_researcher" element={<PrivateRoute><IndependentResearcherLayout/></PrivateRoute>}/>
            <Route path="/marketplace/independent_researcher/post/:id" element={<PrivateRoute><ResearcherPostDetails/></PrivateRoute>}/>
            <Route path="/marketplace/independent_researcher/profile" element={<PrivateRoute><OnBoardingHome/></PrivateRoute>}/>
            <Route path="/marketplace/independent_researcher/payment" element={<PrivateRoute><PaymentsPlans/></PrivateRoute>}/>
            {/* <Route path="/marketplace/university" element={<PrivateRoute><UnversityLayout/></PrivateRoute>}/> */}
            <Route path="/marketplace/university/profile" element={<PrivateRoute><UniversityProfile/></PrivateRoute>}/>
            <Route path="/marketplace/university/status" element={<PrivateRoute><UniversityApprovedStatus/></PrivateRoute>}/>
            <Route path="/marketplace/university/payment" element={<PrivateRoute><UniversityPayment/></PrivateRoute>}/>
            {/* <Route path="/marketplace/industry" element={<PrivateRoute><IndustryLayout/></PrivateRoute>}/> */}
            <Route path="/marketplace/industry/profile" element={<PrivateRoute><IndustryProfile/></PrivateRoute>}/>
            <Route path="/marketplace/industry/status" element={<PrivateRoute><IndustryStatusMessage/></PrivateRoute>}/>
            <Route path="/marketplace/industry/payment" element={<PrivateRoute><IndustryPayment/></PrivateRoute>}/>
            <Route path="/login" element={<MarketPlaceLogin/>}/>
            <Route path="/marketplace/register" element={<PrivateRoute><MarketPlaceRegister/></PrivateRoute>}/>
            {/* end of marketplace routes */}
            {/* Independent Researcher Dashboard routes */}
               <Route
  path="/marketplace/independent_researcher/dashboard"
  element={
   
      <PrivateRoute>
        <ResearcherDashboardLayout />
      </PrivateRoute>
   
  }
>
  <Route index element={<ResearcherDashboard />} />           
  <Route path="publications/" element={<ResearcherPublications />} />
  <Route path="opportunity_hub/" element={<OpportunityHub/>} />
  <Route path="opportunity_hub/create" element={<CreateOpportunity/>} />
  <Route path="opportunity_hub/:id" element={<OpportunityDetails/>} />
  <Route path="opportunity_hub/edit/:id" element={<EditOpportunity/>} />
  <Route path="mylabspaces/" element={<MyLabSpaces/>} />
  <Route path="mylabspaces/createlabopportunity" element={<CreateLabOpportunity/>} />
  <Route path="mylabspaces/lab_opportunity/:id" element={<LabOpportunityDetals owner='member'/>} />
  <Route path="mylabspaces/lab_opportunity/edit/:id" element={<EditLabOpportunity/>} />
  <Route path="mylabspaces/add_lab_theoreticalidea" element={<AddLabTheoreticalIdea/>} />
  <Route path="mylabspaces/add_uni_lab_experiment" element={<AddUniLabExperiment/>} />
  <Route path="mylabspaces/add_lab_prototype" element={<AddLabPrototype/>} />
  <Route path="mylabspaces/add_lab_industrial_application" element={<AddLabIndustrialApplication/>} />
  <Route path="mylabspaces/lab_publication/:id" element={<LabPublicationDetail owner='member'/>} />
  <Route path="mylabspaces/lab_publication/edit/:id" element={<EditLabPublication/>} />
  <Route path="publications/:id" element={<PublicationDetail/>} />
  <Route path="publications/edit/:id" element={<UpdatePublication/>} />
  <Route path="publications/add_theoretical_idea" element={<AddTheoreticalIdea />} />
  <Route path="publications/add_lab_experiment" element={<AddLabExperiment />} />
  <Route path="publications/add_prototype" element={<AddPrototype />} />
  <Route path="publications/add_industrial_application" element={<AddIndustrialApplication/>} />
  <Route path="profile/" element={<ResearcherProfile/>} />
  <Route path="interests/" element={<UsersInterest/>} />
</Route>
            {/* end of independent researcher dashboard routes */}
     {/* University Dashboard routes */}
               <Route
  path="/marketplace/university"
  element={
      <PrivateRoute>
        <UniversityLayout />
      </PrivateRoute>
    }>

  <Route index element={<UniversityDashboard />} /> 
  <Route path="departments/" element={<UniversityDepartments />} />  
  <Route path="departments/add" element={<AddDepartment />} />  
  <Route path="departments/edit/:id" element={<UpdateDepartments />} />  
  <Route path="users/" element={<UniversityUsers />} />
  <Route path="deans/" element={<DeansList />} />
  <Route path="deans/add" element={<AddDean />} />
  <Route path="users/add" element={<AddUniveristyUser />} />  
  <Route path="users/add" element={<AddUniveristyUser />} />    
  <Route path="announcements/" element={<Announcements/>} />  
  <Route path="announcements/create/" element={<CreateAnnouncements/>} />  
  <Route path="announcement/:id" element={<AnnouncementDetail/>} />
  <Route path="teachers/" element={<UniversityTeachers owner='admin'/>} />
  <Route path="teacher/add" element={<AddTeacher/>} />
</Route>
  {/* unviersity dean routes */}
          <Route
  path="/marketplace/:id/dean"
  element={
      <PrivateRoute>
        <UniversityDeanLayout/>
      </PrivateRoute>
   
  }
>
  <Route index element={<UniversityDeanDashboard />} />           
  <Route path="departments" element={<DeanUniversityDepartments />} />
  <Route path="labheads" element={<UniversityLabHeads/>} />
  <Route path="labs" element={<UniversityDeanLabs/>} />
  <Route path="labhead/add" element={<AddLabHead/>} />
  <Route path="lab/add" element={<AddUniversityLab/>} />
  <Route path="announcements/" element={<DeanAnnouncements/>} />
  <Route path="announcement/create/" element={<CreateDeanAnnouncement/>} />  
  <Route path="announcement/:announcementId/" element={<DeanAnnouncementDetail/>} />
  <Route path="teachers/" element={<UniversityTeachers owner='dean'/>} />
  <Route path="teacher/add" element={<AddTeacher/>} />

</Route>

 <Route
  path="/marketplace/:university_name/:dean_name/:department_name/lab/labhead"
  element={
      <PrivateRoute>
        <LabHeadLayout />
      </PrivateRoute>
  }
>
  <Route index element={<LabHeadDashboard />} /> 
  <Route path="/marketplace/:university_name/:dean_name/:department_name/lab/labhead/labs" element={<Labs/>} /> 
  <Route path="/marketplace/:university_name/:dean_name/:department_name/lab/labhead/lab_groups" element={<LabGroups/>} /> 
  <Route path="/marketplace/:university_name/:dean_name/:department_name/lab/labhead/lab_group/add" element={<AddLabGroup/>} />
  <Route path="/marketplace/:university_name/:dean_name/:department_name/lab/labhead/lab_group/edit/:id" element={<EditLabGroup/>} />
  <Route path="/marketplace/:university_name/:dean_name/:department_name/lab/labhead/lab_group/member/add/:groupId" element={<AddGroupMember/>} />   
  <Route path="/marketplace/:university_name/:dean_name/:department_name/lab/labhead/lab_group/member/edit/:id" element={<EditGroupMember/>} /> 
  <Route path="/marketplace/:university_name/:dean_name/:department_name/lab/labhead/announcements" element={<LabHeadAnnouncements/>} />  
  <Route path="/marketplace/:university_name/:dean_name/:department_name/lab/labhead/announcement/create" element={<CreateLabHeadAnnouncements/>} />  
  <Route path="/marketplace/:university_name/:dean_name/:department_name/lab/labhead/announcement/:announcementId/" element={<LabHeadAnnouncementDetail/>} />   
  <Route path="/marketplace/:university_name/:dean_name/:department_name/lab/labhead/teachers" element={<UniversityTeachers owner='labhead'/>} />   
  <Route path="/marketplace/:university_name/:dean_name/:department_name/lab/labhead/teacher/add" element={<AddTeacher/>} />  
  <Route path="/marketplace/:university_name/:dean_name/:department_name/lab/labhead/publications" element={<Publications/>} />  
  <Route path="/marketplace/:university_name/:dean_name/:department_name/lab/labhead/publications/:id" element={<LabPublicationDetail owner='labhead'/>} />  
  <Route path="/marketplace/:university_name/:dean_name/:department_name/lab/labhead/publications/edit/:id" element={<EditLabPublication owner='labhead'/>} />
  <Route path="/marketplace/:university_name/:dean_name/:department_name/lab/labhead/publications/add/theoreticalidea" element={<AddTheoreticalIdea owner='labhead'/>} />
  <Route path="/marketplace/:university_name/:dean_name/:department_name/lab/labhead/publications/add/labexperiment" element={<AddLabExperiment owner='labhead'/>} />
  <Route path="/marketplace/:university_name/:dean_name/:department_name/lab/labhead/publications/add/prototype" element={<AddPrototype owner='labhead'/>} />
  <Route path="/marketplace/:university_name/:dean_name/:department_name/lab/labhead/publications/add/industrialapplication" element={<AddIndustrialApplication owner='labhead'/>} />
  <Route path="/marketplace/:university_name/:dean_name/:department_name/lab/labhead/opportunities" element={<LabHeadOpportunities/>} />
  <Route path="/marketplace/:university_name/:dean_name/:department_name/lab/labhead/opportunities/:id" element={<LabOpportunityDetals owner='labhead'/>} />  
  <Route path="/marketplace/:university_name/:dean_name/:department_name/lab/labhead/opportunities/edit/:id" element={<EditLabOpportunity owner='labhead'/>} />
  <Route path="/marketplace/:university_name/:dean_name/:department_name/lab/labhead/opportunities/add/opportunity" element={<CreateOpportunity owner='labhead'/>} />
</Route>

            {/* end of university dashboard routes */}
   {/* Industry Dashboard routes */}
               <Route
  path="/marketplace/industry"
  element={
      <PrivateRoute>
        <IndustryLayout />
      </PrivateRoute>
   
  }
>
  <Route index element={<ResearcherDashboard />} /> 
  <Route path="managers/" element={<IndustryManagers />} />     
  <Route path="manager/add" element={<AddManager />} />            
  {/* <Route path="course/create" element={<CreateCourse />} /> */}
</Route>
 <Route
  path="/marketplace/industry/manager"
  element={
      <PrivateRoute>
        <ManagerLayout />
      </PrivateRoute>
   
  }
>
  <Route index element={<ManagerDashboard />} /> 
  <Route path="assistant/" element={<AssistantManager />} /> 
  <Route path="assistant/add" element={<AddAssistantManager />} />
</Route>
 <Route
  path="/marketplace/industry/manager/assistant_manager"
  element={
      <PrivateRoute>
        <AssistantManagerLayout />
      </PrivateRoute>
   
  }

>
   <Route index element={<AssistantManagerDashboard />} /> 
 <Route path="posts/" element={<Posts />} /> 
   {/*<Route path="assistant/add" element={<AddAssistantManager />} /> */}
</Route>
            {/* end of industry dashboard routes */}
            <Route
              path="/profile-view/:id"
              element={
                <PrivateRoute>
                  <ProfileView />
                </PrivateRoute>
              }
            />
            <Route
              path="/user-profile/:userId"
              element={
                <PrivateRoute>
                  <ProfileView />
                </PrivateRoute>
              }
            />
            <Route
              path="/home"
              element={
                <PrivateRoute>
                  <HomeTab />
                </PrivateRoute>
              }
            />
            <Route
              path="/publication"
              element={
                <PrivateRoute>
                  <Publication />
                </PrivateRoute>
              }
            />
            <Route
              path="/gallery"
              element={
                <PrivateRoute>
                  <Images />
                </PrivateRoute>
              }
            />
            <Route
              path="/video"
              element={
                <PrivateRoute>
                  <Video />
                </PrivateRoute>
              }
            />
            <Route
              path="/code"
              element={
                <PrivateRoute>
                  <Code />
                </PrivateRoute>
              }
            />
            <Route
              path="/portfolio"
              element={
                <PrivateRoute>
                  <Portfolio />
                </PrivateRoute>
              }
            />
            {/* <Route
          path="/reserch-page"
          element={
            <PrivateRoute>
              <ReserchPage />
            </PrivateRoute>
          }
        /> */}
            <Route
              path="/publish/:type"
              element={
                <PrivateRoute>
                  <Publish />
                </PrivateRoute>
              }
            />
            <Route
              path="/upload-research"
              element={
                <PrivateRoute>
                  <UploadResearch />
                </PrivateRoute>
              }
            />
            <Route
              path="/publish-success"
              element={
                <PrivateRoute>
                  <PublishSuccess />
                </PrivateRoute>
              }
            />
            <Route
              path="/user-profile/:userId"
              element={
                <PrivateRoute>
                  <UserProfile />
                </PrivateRoute>
              }
            />

            <Route
              path="/profile-view"
              element={
                <PrivateRoute>
                  <ProfileView />
                </PrivateRoute>
              }
            />
            <Route
              path="/home"
              element={
                <PrivateRoute>
                  <HomeTab />
                </PrivateRoute>
              }
            />
            <Route
              path="/publication"
              element={
                <PrivateRoute>
                  <Publication />
                </PrivateRoute>
              }
            />
            <Route
              path="/gallery"
              element={
                <PrivateRoute>
                  <Images />
                </PrivateRoute>
              }
            />
            <Route
              path="/video"
              element={
                <PrivateRoute>
                  <Video />
                </PrivateRoute>
              }
            />
            <Route
              path="/code"
              element={
                <PrivateRoute>
                  <Code />
                </PrivateRoute>
              }
            />
            <Route
              path="/portfolio"
              element={
                <PrivateRoute>
                  <Portfolio />
                </PrivateRoute>
              }
            />
            {/* <Route
            path="/reserch-page"
            element={
              <PrivateRoute>
                <ReserchPage />
              </PrivateRoute>
            }
          /> */}
            <Route
              path="/publish/:type"
              element={
                <PrivateRoute>
                  <Publish />
                </PrivateRoute>
              }
            />
            <Route
              path="/upload-research"
              element={
                <PrivateRoute>
                  <UploadResearch />
                </PrivateRoute>
              }
            />
            <Route
              path="/publish-success"
              element={
                <PrivateRoute>
                  <PublishSuccess />
                </PrivateRoute>
              }
            />
            {/* <Route
              path="/user-profile/:userId"
              element={
                <PrivateRoute>
                  <UserProfile />
                </PrivateRoute>
              }
            /> */}
            <Route
              path="/post/:id"
              element={
                <PrivateRoute>
                  <PostDetail />
                </PrivateRoute>
              }
            />
              {/* Teacher Routes */}
            <Route
  path="/teacher"
  element={
   
      <PrivateRoute>
        <TeacherLayout />
      </PrivateRoute>
   
  }
>
  <Route index element={<TeacherDashboard />} />           
  <Route path="course" element={<TeacherCourses />} />     
  <Route path="course/create" element={<CreateCourse />} />
  <Route path="course/:id" element={<TeacherCourseDetail />} />
  <Route path="course/edit/:id" element={<EditCourse/>}/>
  <Route path="course/list-content/:id" element={<ListCourseContent/>}/>
  <Route path="profile" element={<TeacherProfile />} />
  <Route path="videos/" element={<ListVideos/>}/>
  <Route path="videos/video/:type/:id" element={<VideoDetails/>}/>
  <Route path="videos/video/edit/:id" element={<EditVideo/>}/>
  <Route path="videos/upload" element={<UploadVideo/>}/>
  <Route path="audios/" element={<ListAudios/>}/>
  <Route path="audios/audio/:type/:id" element={<AudioDetails/>}/>
  <Route path="audios/audio/edit/:id" element={<EditAudio/>}/>
  <Route path="audios/upload" element={<UploadAudio/>}/>
  <Route path="podcasts/" element={<ListPodCasts/>}/>
  <Route path="podcasts/podcast/:type/:id" element={<PodCastDetails/>}/>
  <Route path="podcasts/podcast/edit/:id" element={<EditPodCast/>}/>
  <Route path="podcasts/upload" element={<UploadPodCast/>}/>
</Route>

   
  <Route
    path="/teacher-profile"
    element={
      isTeacher ? (
        <Navigate to="/teacher" replace />   // redirect if already a teacher
      ) : (
        <PrivateRoute>
          <TeacherPrfilePage />
        </PrivateRoute>
      )
    }
  />
  {/* End of Teacher Routes */}
  {/* Courses Routes  */}
    <Route
              path="/courses"
              element={
                <PrivateRoute>
                  <CoursesPage />
                </PrivateRoute>
              }
            />
             <Route
              path="course/:teacher_id/:learning_type/:id"
              element={
                <PrivateRoute>
                  <CourseDetailsPage />
                </PrivateRoute>
              }
            />
            <Route path="/teacher-profile/:id"
            element={
              <PrivateRoute>
                <TeacherProfilePublicView/>
              </PrivateRoute>
            }
            />
  {/* End of Courses Routes */}
  {/* Student Routes */}
   <Route
  path="/student"
  element={
   
      <PrivateRoute>
        <StudentLayout/>
      </PrivateRoute>
   
  }
>
  <Route index element={<StudentDashboard />} />           
  <Route path="courses" element={<MyCourses />} />     
  <Route path="playlist" element={<PlayLists />} />
  <Route path="videos" element={<VideoCourses />} /> 
  <Route path="audios" element={<AudioCourses />} />
  <Route path="podcasts" element={<PodCastCourses />} />
  <Route path="playlist/:id" element={<PlayListCourseDetailPage/>}/>
  {/* <Route path="videos/" element={<ListVideos/>}/>
  <Route path="videos/upload" element={<UploadVideo/>}/>
  <Route path="audios/" element={<ListAudios/>}/>
  <Route path="podcasts/" element={<ListPodCasts/>}/> */}
</Route>
  {/* End of Student Routes */}
          </Routes>
        
        </ProfileProvider>
      </Router>
    </QueryClientProvider>
  );
}

export default App;
